<toast-notification #toastNotification></toast-notification>

<div class="acs-toolbar-scroll">
  <div class="acs-toolbar">
    <div class="acs-flex acs-flex--center acs-gap-md">
      <div class="acs-flex acs-flex--center">
        <i class="fa-solid fa-building acs-dropdown__icon" title="Trade Unit"></i>
        <div class="acs-dropdown" (click)="$event.stopPropagation()">
          <button type="button" class="acs-dropdown__trigger" (click)="toggleLocDropdown()"
                  [class.acs-dropdown__trigger--placeholder]="!locDropdown.selectedValue">
            {{locDropdown.displayText}}
            <i class="fa-solid fa-chevron-down acs-dropdown__arrow"></i>
          </button>
          <div class="acs-dropdown__panel" *ngIf="locDropdown.isOpen()">
            <input class="acs-dropdown__search" type="text" placeholder="Search..."
                   [ngModel]="locDropdown.searchText()" (ngModelChange)="locDropdown.searchText.set($event)"
                   (click)="$event.stopPropagation()" />
            <div class="acs-dropdown__options">
              <div class="acs-dropdown__option acs-dropdown__option--placeholder"
                   (click)="selectLoc({id: 0, value: '', text: ''})">-- Select Trade Unit --</div>
              <div *ngFor="let loc of locDropdown.filtered"
                   class="acs-dropdown__option"
                   [class.acs-dropdown__option--selected]="loc.value === locDropdown.selectedValue"
                   (click)="selectLoc(loc)">{{loc.text}}</div>
              <div *ngIf="locDropdown.filtered.length === 0" class="acs-dropdown__empty">No matches</div>
            </div>
          </div>
        </div>
      </div>
      <div class="acs-flex acs-flex--center">
        <i class="fa-solid fa-wheat-awn acs-dropdown__icon" title="Commodity"></i>
        <div class="acs-dropdown" (click)="$event.stopPropagation()">
          <button type="button" class="acs-dropdown__trigger" (click)="toggleCommodityDropdown()"
                  [class.acs-dropdown__trigger--placeholder]="!selectedCommodityCode">
            {{selectedCommodityDisplay}}
            <i class="fa-solid fa-chevron-down acs-dropdown__arrow"></i>
          </button>
          <div class="acs-dropdown__panel" *ngIf="dropdowns.isOpen('ba-commodity')">
            <input class="acs-dropdown__search" type="text" placeholder="Search..."
                   [ngModel]="commoditySearchText()" (ngModelChange)="commoditySearchText.set($event)"
                   (click)="$event.stopPropagation()" />
            <div class="acs-dropdown__options">
              <div class="acs-dropdown__option acs-dropdown__option--placeholder"
                   (click)="selectCommodity({id: 0, value: '', text: ''})">-- Select Commodity --</div>
              <div class="acs-dropdown__option"
                   [class.acs-dropdown__option--selected]="selectedCommodityCode === 'All*'"
                   (click)="selectCommodity({id: 0, value: 'All*', text: 'All*'})">All*</div>
              <div *ngFor="let c of filteredCommodityList"
                   class="acs-dropdown__option"
                   [class.acs-dropdown__option--selected]="c.value === selectedCommodityCode"
                   (click)="selectCommodity(c)">{{c.text}}</div>
              <div *ngIf="filteredCommodityList.length === 0" class="acs-dropdown__empty">No matches</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="acs-toolbar__actions">
      <small *ngIf="billAddresses.length > 0" class="acs-text-muted">{{billAddresses.length}} address(es)</small>
      <button type="button" class="acs-action-btn acs-action-btn--danger"
              [disabled]="bulkDelete.selectedCount === 0"
              (click)="bulkDelete.requestDelete()">
        <i class="fa-solid fa-trash"></i> Delete<span *ngIf="bulkDelete.selectedCount > 0"> ({{bulkDelete.selectedCount}})</span>
      </button>
      <button type="button" class="acs-action-btn acs-action-btn--accent"
              (click)="openAdd()" [disabled]="!locDropdown.selectedValue">
        <i class="fa-solid fa-plus"></i> Add
      </button>
    </div>
  </div>

  <!-- Empty state -->
  <div *ngIf="!locDropdown.selectedValue && !selectedCommodityCode" class="acs-table-wrap--connected acs-empty-state-wrap">
    <div class="acs-empty-state">
      <i class="fa-solid fa-address-card"></i>
      Select a trade unit or commodity to view billing addresses
    </div>
  </div>

  <div *ngIf="locDropdown.selectedValue || selectedCommodityCode" class="acs-table-wrap acs-table-wrap--connected acs-table--contained">
    <table class="acs-table acs-table--striped acs-table--hover acs-table--bordered">
      <thead class="acs-thead--primary acs-sticky">
        <tr>
          <th class="acs-table__checkbox-col">
            <input type="checkbox" class="acs-table__checkbox"
                   [checked]="bulkDelete.allVisibleSelected && billAddresses.length > 0"
                   (change)="bulkDelete.toggleSelectAll()">
          </th>
          <th>Trade Unit</th>
          <th>Commodity</th>
          <th>Billing Address</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of billAddresses" class="acs-cursor-pointer" (click)="openEdit(item)">
          <td class="acs-table__checkbox-col" (click)="$event.stopPropagation()">
            <input type="checkbox" class="acs-table__checkbox"
                   [checked]="bulkDelete.isSelected(item.locDefaultId)"
                   (change)="bulkDelete.toggle(item.locDefaultId, $event)">
          </td>
          <td>{{item.locCode}}</td>
          <td>{{item.commodityCode || 'All*'}}</td>
          <td class="acs-pre-line">{{item.value}}</td>
        </tr>
        <tr *ngIf="billAddresses.length === 0">
          <td colspan="4" class="acs-text-center acs-text-muted">No billing addresses found</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Edit/Add Dialog -->
<div *ngIf="showDialog" class="acs-modal" tabindex="-1">
  <div class="acs-modal__dialog">
    <div class="acs-modal__content">
      <div class="acs-modal__header">
        <h6 class="acs-modal__title">Billing Address</h6>
        <button type="button" class="acs-btn--close" (click)="closeDialog()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="acs-modal__body">
        <div class="acs-row acs-mb-2">
          <div class="acs-col--md6">
            <label class="acs-label">Trade Unit</label>
            <input class="acs-input" [value]="editingItem.locCodeDisplay" disabled />
          </div>
          <div class="acs-col--md6">
            <label class="acs-label">Commodity</label>
            <input *ngIf="editingItem.locDefaultId > 0" class="acs-input" [value]="editingItem.commodityDisplay" disabled />
            <div *ngIf="editingItem.locDefaultId === 0" class="acs-dropdown acs-dropdown--full" (click)="$event.stopPropagation()">
              <button type="button" class="acs-dropdown__trigger"
                      (click)="toggleModalCommodityDropdown()"
                      [class.acs-dropdown__trigger--placeholder]="!editingItem.commodityCode">
                {{editingItem.commodityDisplay}}
                <i class="fa-solid fa-chevron-down acs-dropdown__arrow"></i>
              </button>
              <div class="acs-dropdown__panel" *ngIf="dropdowns.isOpen('ba-modal-commodity')">
                <input class="acs-dropdown__search" type="text" placeholder="Search..."
                       [ngModel]="modalCommoditySearchText()" (ngModelChange)="modalCommoditySearchText.set($event)"
                       (click)="$event.stopPropagation()" />
                <div class="acs-dropdown__options">
                  <div class="acs-dropdown__option"
                       [class.acs-dropdown__option--selected]="editingItem.commodityCode === 'All*'"
                       (click)="selectModalCommodity({id: 0, value: 'All*', text: 'All*'})">All*</div>
                  <div *ngFor="let c of filteredModalCommodityList"
                       class="acs-dropdown__option"
                       [class.acs-dropdown__option--selected]="c.value === editingItem.commodityCode"
                       (click)="selectModalCommodity(c)">{{c.text}}</div>
                  <div *ngIf="filteredModalCommodityList.length === 0" class="acs-dropdown__empty">No matches</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="acs-row acs-mb-2">
          <div class="acs-col--12">
            <label class="acs-label">Billing Address</label>
            <textarea class="acs-textarea" rows="6" [(ngModel)]="editingItem.value"></textarea>
          </div>
        </div>
      </div>
      <div class="acs-modal__footer">
        <button class="acs-btn acs-btn--secondary" (click)="closeDialog()">Cancel</button>
        <button class="acs-btn acs-btn--primary" (click)="save()">
          {{editingItem.locDefaultId > 0 ? 'Update' : 'Save'}}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Bulk Delete Confirmation Dialog -->
<div *ngIf="bulkDelete.showConfirm" class="acs-modal" tabindex="-1">
  <div class="acs-modal__dialog acs-modal__dialog--sm">
    <div class="acs-modal__content">
      <div class="acs-modal__header">
        <h6 class="acs-modal__title">Confirm Delete</h6>
        <button type="button" class="acs-btn--close" (click)="bulkDelete.cancelDelete()" [disabled]="bulkDelete.isDeleting">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="acs-modal__body">
        <p>Delete <strong>{{bulkDelete.selectedCount}}</strong> billing address(es)? This action cannot be undone.</p>
      </div>
      <div class="acs-modal__footer">
        <button class="acs-btn acs-btn--secondary" (click)="bulkDelete.cancelDelete()" [disabled]="bulkDelete.isDeleting">Cancel</button>
        <button class="acs-btn acs-btn--danger" (click)="confirmBulkDelete()" [disabled]="bulkDelete.isDeleting">
          {{bulkDelete.isDeleting ? 'Deleting...' : 'Yes, Delete'}}
        </button>
      </div>
    </div>
  </div>
</div>

